import React from "react";
import "./international.css";
import internationalImage from "../images/international.jpeg";

export default function International() {
  return (
    <div className="international-container">
      <div className="international-image">
        <img src={internationalImage} alt="International Fairs" />
      </div>
    </div>
  );
}